import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISubmit } from '@interfaces';
import { DraftStatus, DraftType, ExperienceType } from '@shared/models/draft';
import { Observable } from 'rxjs';

import type { CooDraftDetails } from '../hydration/ku4-draft.models';

export interface SaveNewDraftPayload {
  draftType: string;
  status: string;
  communicationChannel: string;
  draftDetails: {
    processTrackingId: string;
    experienceType: ExperienceType;
  };
}

export interface SaveNewDraftResponse {
  draftId: string;
  expDate: string;
}

export interface RetrieveDraftItem {
  communicationChannel: string;
  status: string;
  createdDateTime: string;
  draftType: string;
  draftId: string;
  draftDetails: CooDraftDetails & {
    processTrackingId: string;
    experienceType: ExperienceType;
  };
  expDate: number;
}

@Injectable({
  providedIn: 'root',
})
export class DraftService {
  constructor(private http: HttpClient) {}

  saveNewDraft(
    processTrackingId: string,
    communicationChannel: string,
    experienceType: ExperienceType,
  ): Observable<SaveNewDraftResponse> {
    const payload: SaveNewDraftPayload = {
      draftType: DraftType.CHANGE_OF_OWNERSHIP,
      status: DraftStatus.READY_FOR_CLIENT,
      communicationChannel,
      draftDetails: {
        processTrackingId,
        experienceType,
      },
    };

    return this.http.post<SaveNewDraftResponse>('secure/create-draft', payload);
  }

  retrieveDrafts(draftType: string): Observable<RetrieveDraftItem[]> {
    return this.http.get<RetrieveDraftItem[]>('secure/retrieve-drafts', {
      params: { draftType },
    });
  }

  updateDraft(draftId: string, submitPayload: ISubmit): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`secure/update-draft/${draftId}`, submitPayload);
  }

  deleteDraft(draftId: string, skipDocumentCleanup?: boolean): Observable<{ draftId: string }> {
    const options = skipDocumentCleanup ? { params: { skipDocumentCleanup: 'true' } } : {};
    return this.http.delete<{ draftId: string }>(`secure/delete-draft/${draftId}`, options);
  }
}
